import { render, staticRenderFns } from "./ImportProjectWarning.vue?vue&type=template&id=4fda2aec&scoped=true&"
import script from "./ImportProjectWarning.vue?vue&type=script&lang=js&"
export * from "./ImportProjectWarning.vue?vue&type=script&lang=js&"
import style0 from "./ImportProjectWarning.vue?vue&type=style&index=0&id=4fda2aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fda2aec",
  null
  
)

export default component.exports